import React, {Fragment, useState} from 'react';
import {makeApiCall} from '../../Api/makeApiCall';
import PropTypes from 'prop-types';
import sound from '../../assets/flush.mp3'
import ConfirmationModal from "../../Dashboard/Components/ConfirmationModal";
import {toast} from "react-toastify";
import _ from 'lodash';
import {toastError, toastSuccess} from "../toast";
import {faIcons} from "../iconConstants";

export const ButtonLoader = ({
    axiosFunction = makeApiCall,
    buttonClassName = 'button hollow secondary',
    buttonHasModal = false,
    buttonProps = {},
    confirmationsModalClass = 'confirmation-modal',
    includeApiError = false,
    postBody = undefined,
    toastTextFailure = undefined,
    toastTextSuccess = undefined,
    userAcknowledgedCheck = false,
    onSubmitCallback = _.identity,
    buttonOnClickAction = _.identity,
    onClose = _.identity,
    ...props
}) => {

    const [loading, setLoading] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [isChecked, setIsChecked] = useState(!userAcknowledgedCheck);

    const getOnClick = async () => {
        if (buttonHasModal) {
            setLoading(true);
            await buttonOnClickAction()
            setLoading(false);
            return setModalIsOpen(true)
        }
        return fetchData()

    }

    const closeModal = () => {
        setIsChecked(!userAcknowledgedCheck)
        setModalIsOpen(false)
        onClose()
    }

    const fetchData = async () => {
        setLoading(true);
        if (props.playSound) {
            let snd = new Audio(sound);
            await snd.play();
        }
        if (props.clickAction) {
            await props.clickAction();
        } else {
            const result = await axiosFunction(props.url, postBody);
            onSubmitCallback(result);
            if (toastTextFailure || toastTextSuccess) {
                if (result?.apiError) {
                    const errorMessage = includeApiError ?
                        toastTextFailure + " " + JSON.stringify(result.apiError.data.detail) :
                        toastTextFailure;
                    toastError(toast, errorMessage);
                } else
                    toastSuccess(toast, toastTextSuccess)
            }
        }
        setModalIsOpen(false)
        setLoading(false);
    };
    return (
        <Fragment>
            {modalIsOpen &&
            <ConfirmationModal confirmationCallback={fetchData}
                               cancellationCallback={closeModal}
                               headerText={props.modalHeader}
                               submitButtonDisabled={!isChecked}
                               loading={loading}
            >
                <div className={confirmationsModalClass}>
                    {props.modalChildren}
                    <div className={'confirmation-modal-body'}>{props.modalText}</div>

                    {userAcknowledgedCheck && <>
                        <input className={'user-confirmation-checkbox'}
                               data-testid={'user-confirmation-checkbox'}
                               type="checkbox"
                               checked={isChecked}
                               onChange={() => setIsChecked(!isChecked)}
                        />
                        <label className={'checkbox-label'}>{"I understand this can not be undone"}</label>
                    </>
                    }
                </div>
            </ConfirmationModal>
            }
            <button className={buttonClassName} onClick={getOnClick}
                    title={props.title}
                    disabled={props.disabled || loading} {...buttonProps}>
                {loading && (<><i className={`${faIcons.spinner} fa-spin`} data-testid={"spinner"}/><span>Loading</span></>)}
                {!loading && props.buttonTitle}
            </button>
        </Fragment>
    );
}

ButtonLoader.propTypes = {
    axiosFunction: PropTypes.func,
    buttonOnClickAction: PropTypes.func,
    buttonClassName: PropTypes.string,
    buttonHasModal: PropTypes.bool,
    buttonProps: PropTypes.object,
    buttonTitle: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    clickAction: PropTypes.func,
    confirmationsModalClass: PropTypes.string,
    includeApiError: PropTypes.bool,
    modalHeader: PropTypes.string,
    modalText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    postBody: PropTypes.object,
    playSound: PropTypes.bool,
    title: PropTypes.string,
    toastTextSuccess: PropTypes.string,
    toastTextFailure: PropTypes.string,
    url: PropTypes.string,
    userAcknowledgedCheck: PropTypes.bool,
    disabled: PropTypes.bool,
    onSubmitCallback: PropTypes.func,
    onClose: PropTypes.func,
    modalChildren: PropTypes.element
};

export default ButtonLoader